module.exports = __webpack_public_path__ + "img/livraison-big-icon.2e7a4953.svg";